(function () {
    'use strict';

    angular.module("imApp").factory("postAccrualService", ['$ihttp', function ($ihttp) {
        let service = {
            getEdit: function (parms) {
                return $ihttp.post({
                    method: 3191,
                    parameters: parms || {}
                });
            },
            performAccountObj: function (edit) {
                return $ihttp.post({
                    method: 3193,
                    parameters: edit
                });
            }
        };

        return service;
    }]);
})();
